module.exports = __webpack_public_path__ + "static/media/users-list.021a6fb4.jpg";